import Container from "Components/Container/Container";
import SectionHeader from "Components/SectionHeader/SectionHeader";
import FadeInAnimation from "Components/FadeInAnimation/FadeInAnimation";
import Reavel from "Components/Reveal/Reavel";
import aqbmImage from "assets/images/aqbm.png";
import facebookImage from "assets/images/facebook.png";
import aqbmWebsiteImage from "assets/images/aqbm_website.jpg";

const Aqbm = () => {

  return (
    <div className="bg-gray-800 pb:10 md:pb-20 pt-4" id="aqbm">
      <SectionHeader heading={"Découvrez l'AQBM"} />
      <Container>
        <div className="grid grid-cols-1 gap-10 mb-8">
          <FadeInAnimation>
            <div className="flex flex-col lg:flex-row-reverse justify-center items-center gap-10">
              <div>
                <Reavel>
                  <p className="text-white text-slate-700">
                    L'AQBM, ou Association Québécoise de Babyfoot Multitable, est
                    une organisation dédiée à la promotion et à la pratique du
                    babyfoot au Québec. Son objectif principal est
                    d'organiser des tournois provinciaux pour rassembler les passionnés de
                    ce jeu emblématique. Ces compétitions permettent aux joueurs
                    de tous niveaux de s'affronter dans un esprit de camaraderie
                    et de compétition amicale. Grâce à ses tournois, l'AQBM
                    contribue à l'engouement croissant pour le babyfoot, offrant
                    ainsi une plateforme dynamique pour les joueurs et
                    renforçant la communauté autour de ce sport.
                  </p>
                </Reavel>
              </div>
            </div>
          </FadeInAnimation>
        </div>

        <div className="flex flex-row flex-wrap justify-center items-center gap-4 pb-4">
          <a href="https://www.aqbb.ca" target="_blank" rel="noopener noreferrer">
            <div className="relative overflow-hidden rounded-lg">
              <img
                alt="gallery"
                loading="lazy"
                className="hebdos_card_img h-60"
                src={aqbmWebsiteImage}
              />
              <div className="hebdos_card_overlay"></div>
            </div>
          </a>
          <div className="relative overflow-hidden rounded-lg">
            <img
              alt="gallery"
              loading="lazy"
              className="hebdos_card_img h-60 bg-white"
              src={aqbmImage}
            />
            <div className="absolute inset-0 text-white top-0 left-0">
              <a
                href="https://www.facebook.com/aqbmfoosball"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center"
              >
                <img
                  loading="lazy"
                  src={facebookImage}
                  alt=""
                  className="w-16 h-16"
                />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Aqbm;
